import React from 'react';
import classNames from 'classnames';
import { Card, CardContent, CardHeader } from '@mui/material';
import ProgressIndicator from '../../progressIndicator/components/ProgressIndicator';
import ListRowDragLayer from './ListRowDragLayer';
import AccurityIcon from '../../icon/components/AccurityIcon';
export var List = function (_a) {
    var isProgressBarShown = _a.isProgressBarShown, className = _a.className, Content = _a.Content, ActionButton = _a.ActionButton, icon = _a.icon, PinFilters = _a.PinFilters, HeaderRightNode = _a.HeaderRightNode, FooterContent = _a.FooterContent, title = _a.title;
    return (React.createElement(Card, { className: classNames('list', className) },
        isProgressBarShown && React.createElement(ProgressIndicator, { className: "list__progressIndicator" }),
        React.createElement(CardHeader, { className: "listHeader", avatar: React.createElement("div", { className: "listHeader__inner" },
                React.createElement("div", { className: "listHeader__leftNodes" },
                    ActionButton,
                    React.createElement(AccurityIcon, { iconName: icon, sx: { marginX: 2 } }),
                    React.createElement("div", { className: "listHeader__title" }, title),
                    PinFilters && React.createElement("div", { className: "listHeader__pinFilters" }, PinFilters)),
                HeaderRightNode && React.createElement("div", { className: "listHeader__rightNodes" }, HeaderRightNode)) }),
        React.createElement(CardContent, { className: "listContent" }, Content),
        React.createElement(CardContent, { className: "listFooter" }, FooterContent),
        React.createElement(ListRowDragLayer, null)));
};
export default List;
//# sourceMappingURL=List.js.map